<template>
<div>
  <vs-row>
    <vs-col id="reasonNew" vs-lg="8" vs-sm="8" vs-xs="12">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input 
            name="description" 
            v-validate="'required'" 
            class="mb-4 w-full" 
            label-placeholder="Título da Métrica Inteligente" 
            v-model="description"
          ></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('description')">
            Informe um valor válido para o Título.
          </span>
        </div>
      </div> 

      <div class="mb-8">
        <vs-row>
          <vs-col vs-w="6">
            <div class="w-full flex">
              <span>Exibir Campo de Observação?</span>
            </div>
            <div class="w-full mt-4 flex">
              <vs-switch v-model="useObservation">
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </vs-col>

          <vs-col vs-w="6" v-if="useObservation">
            <div>
              <div class="w-full flex">
                <span>Observação Obrigatória?</span>
              </div>
              <div class="w-full mt-4 flex">
                <vs-switch v-model="requireObservation">
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div> <hr>

      <div>
        <div class="mt-5 text-center">
          <h6>OPÇÕES</h6>
          <p v-if="options.length === 0">Nenhuma opção cadastrada</p>
        </div>

        <component
          :index="index"
          @onRemoveReasonOption="removeReasonOption"
          :list="reasonOptionsAttributes[index]"
          v-for="(option, index) in options"
          :key="index"
          :is="option"
          class="body mt-5"
        />

        <vs-button 
          type="flat" 
          @click.prevent="addOption"
        >
          Adicionar Opção
        </vs-button>
      </div>

      <div class="w-full d-flex justify-content-flex-end"
      >
        <vs-button @click.prevent="update">Salvar</vs-button>
      </div>
      
    </vs-col>
    <vs-col vs-lg="4" vs-sm="4" vs-xs="0">
      <div style="position: sticky; top: 0; padding-top: 15px">
        <reasons-preview :use_observation="useObservation" :reason_options.sync="reasonOptionsAttributes"></reasons-preview>
      </div>
    </vs-col>
  </vs-row>
</div>
</template>

<script>
  import requests from '@/http/requests/reasons'
  import ReasonOptionForm from '@/views/reason-options/Form'
  import ReasonsPreview from "@/components/reasons/ReasonsPreview.vue";
  import { formatRouteTenantPath } from '@/utils'
  import { reasonType } from '@/supports/reasonSupport'
  export default {
    name: 'reasons-form-popup',
    components: { ReasonsPreview, ReasonOptionForm },
    provide() {
      return { $validator: this.$validator }
    },
    data() {
      return {
        id: null,
        options: [],
        reasonOptionsAttributes: [],
        reasonOptionsAttributesRemoved: [],
        description: '',
        useObservation: false,
        requireObservation: false,
      }
    },
    mounted () {
      this.id = this.$route.params.id;
    },
    created () {
      this.loadReason();
    },
    methods: {
      loadReason () {
        this.$store.dispatch('setShowLoadingOverlay', true)

        requests.get(this.$route.params.id).then((response) => {
          let reason = response.data.data.reasons[0]

          if (reason) {
            this.description = reason.description
            this.useObservation = reason.use_observation
            this.requireObservation = reason.require_observation

            let opts = reason.reason_options
            opts = JSON.stringify(opts)
            opts = opts.replaceAll('reason_option_items', 'reason_option_items_attributes')
            opts = JSON.parse(opts)

            this.reasonOptionsAttributes = opts

            let currentOptions = []
            this.reasonOptionsAttributes.forEach(() => {
              currentOptions.push(ReasonOptionForm)
            })

            this.options = currentOptions
            this.$store.dispatch('setShowLoadingOverlay', false)
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Erro!',
              text: 'A Métrica Inteligente não foi encontrada'
            })

            this.$store.dispatch('setShowLoadingOverlay', false)
            this.$router.push(formatRouteTenantPath('/crm/reasons'))
          }
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.log(error)
        })
      },
      addOption () {
        this.reasonOptionsAttributes.push({
          description: '',
          is_required: false,
          number: this.options.length,
          reason_option_items_attributes: []
        })

        this.options.push(ReasonOptionForm);
      },
      removeReasonOption (idx, {id = null, reasonOptionId = null}) {
        if (id && reasonOptionId) {
          return this.reasonOptionsAttributesRemoved.push({
            id: id,
            reason_option_id: reasonOptionId
          });
        }

        if ( this.reasonOptionsAttributes[idx].id ) {
          this.reasonOptionsAttributesRemoved.push({
            id: this.reasonOptionsAttributes[idx].id
          });
        }

        this.reasonOptionsAttributes.splice(idx, 1)
        this.options.splice(idx, 1)
      },
      update () {
        this.$validator.validateAll().then((valid) => {
          if(!valid) {
            return
          }

          this.$store.dispatch('setShowLoadingOverlay', true)

          let dataToPost = this.reasonOptionsAttributes

          dataToPost.map((item, key) => {
            if(item){
              item.number = key
              delete item["reason_option_kind"]
              return item
            }
          });

          let args = {
            type: reasonType,
            id: Number.parseInt(this.id),
            description: this.description,
            use_observation: this.useObservation,
            require_observation: this.requireObservation,
            reason_options_attributes: dataToPost,
            reason_options_attributes_removed: this.reasonOptionsAttributesRemoved
          }

          this.$store.dispatch('setShowLoadingOverlay', true)

          requests.update(args).then(() => {
            this.$store.dispatch('setShowLoadingOverlay', false);
            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'A Métrica Inteligente foi editada com sucesso'
            })
            this.$router.push(formatRouteTenantPath('/crm/reasons'))
          }).catch((error) => {
            this.$store.dispatch('setShowLoadingOverlay', false)
            console.log(error)
          })
        })
      }
    },
  }
</script>


<style lang="scss">
  #reasonNew {
    .body {
      border: none;
      padding: 10px; 
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.090);
    }
  }
</style>